import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Properties from "@/components/Properties";
import Footer from "@/components/Footer";
import PageSeo from "@/components/PageSeo";
import { 
  OrganizationStructuredData, 
  FAQStructuredData, 
  WebSiteStructuredData,
  PersonStructuredData 
} from "@/components/StructuredData";

// Lazy load below-the-fold components to reduce initial bundle size
const Services = lazy(() => import("@/components/Services"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const Insights = lazy(() => import("@/components/Insights"));
const Contact = lazy(() => import("@/components/Contact"));
const CtaSection = lazy(() => import("@/components/CtaSection"));

const homeFAQs = [
  {
    question: "What types of properties does Brant Booker specialize in?",
    answer: "Brant specializes in luxury homes, new construction, investment properties, and condominiums across Chicago's premier neighborhoods including Gold Coast, Lincoln Park, River North, Lakeview, and Wicker Park.",
  },
  {
    question: "How much experience does Brant Booker have in Chicago real estate?",
    answer: "Brant has over 20 years of experience in Chicago real estate, with more than $900 million in sales and 1,900+ successful transactions.",
  },
  {
    question: "What areas in Chicago does Brant Booker serve?",
    answer: "Brant serves Chicago's premier neighborhoods including Gold Coast, Lincoln Park, River North, Lakeview, Wicker Park, and surrounding areas.",
  },
  {
    question: "How can I contact Brant Booker for real estate services?",
    answer: "You can reach Brant via email at bbooker@jamesonsir.com, through the contact form on the website, or by visiting the contact page at brantbooker.com/contact.",
  },
  {
    question: "Does Brant Booker help first-time homebuyers?",
    answer: "Yes, Brant provides comprehensive support for first-time homebuyers including market education, financing guidance, inspection coordination, and negotiation support.",
  },
];

// Minimal loading fallback that doesn't affect layout
const SectionFallback = () => (
  <div className="min-h-[200px]" aria-hidden="true" />
);

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageSeo 
        defaultTitle="Brant Booker | Chicago Luxury Real Estate | Jameson Sotheby's International Realty"
        defaultDescription="Brant Booker has sold over $900M in Chicago real estate with 1,900+ transactions. 20+ years of expertise in luxury homes, new construction, and investments."
        defaultKeywords="Chicago luxury real estate, Brant Booker, Jameson Sotheby's, Lincoln Park homes, Gold Coast real estate"
      />
      <OrganizationStructuredData />
      <WebSiteStructuredData />
      <PersonStructuredData />
      <FAQStructuredData faqs={homeFAQs} />
      <Header />
      <main id="main-content">
        <Hero />
        <About />
        <Properties />
        <Suspense fallback={<SectionFallback />}>
          <Services />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Testimonials />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Insights />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Contact />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <CtaSection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
